<template>
  <div v-if="modal">
    <div class="modal-pdv show">
      <div class="modal-pdv-content" :class="{'modal-admin': admin}">
        <div class="container-fluid">
          <div class="row no-gutters align-items-center justify-content-between border-bottom mb-2">
            <div class="col-md-6 pr-md-1 mb-2 text-ellipsis">
              {{cliente.nome_cliente}}
            </div>
            <div class="col-md-3 pr-2 mb-2" v-show="menu === 1">
              <select class="form-control ml-auto" v-model="pesquisa.status" @change="buscarDebitos()">
                <option value="">Todos</option>
                <option value="1">Abertos</option>
                <option value="2">Pagos</option>
                <option value="3">Vencidos</option>
              </select>
            </div>
            <div class="col-md-3 text-right mb-2" v-show="menu === 1">
              <button class="btn btn-block btn-secondary" @click="incluirDebito" title="Adicionar" v-if="!selecionados.length">
                <i class="fa fa-plus"></i>
                <span class="ml-1 d-md-none">Adicionar</span>
              </button>
              <button v-else class="btn btn-block btn-third" title="Imprimir" @click="comprovanteDebito()">
                <i class="fa fa-print"></i>
                <span class="ml-1 d-md-none">Imprimir</span>
              </button>
            </div>
            <div class="col-md-6 text-right mb-2" v-show="menu === 2 && dadosDebito.id_debito">
              <button class="btn btn-third mr-1" title="Imprimir" @click="comprovanteDebito(dadosDebito.id_debito)"><i class="fa fa-print"></i></button>
              <button class="btn btn-primary" title="Remover" @click="removerDebito()" v-if="dadosDebito.status === '1'"><i class="fa fa-trash-alt"></i></button>
              <button class="btn btn-primary px-4" @click="reabrirDebito()" v-else>Reabrir</button>
            </div>
          </div>
          <div v-show="menu === 1">
            <div class="row no-gutters">
              <div class="col-md-8 pr-md-2">
                <div class="border rounded height-75">
                  <div class="table-responsive">
                    <table class="table table-sm mb-0" v-show="debitos.length">
                      <tr class="bg-light">
                        <th style="width: 36px">
                          <input type="checkbox" class="ml-2" @change="selTodos" :checked="selecionados.length === debitos.length">
                        </th>
                        <th>Débitos</th>
                        <th>&nbsp;</th>
                      </tr>
                      <tr v-for="d in debitos">
                        <td>
                          <input type="checkbox" :id="d.id_debito" class="ml-2" :value="d" v-model="selecionados">
                        </td>
                        <td class="align-middle pointer">
                          <label :for="d.id_debito" class="pointer mb-0">
                            <span class="badge badge-dark" v-if="d.status === '2'">Pago</span>
                            <span class="badge badge-success" v-else>Aberto</span><br>
                            <span class="d-block small">
                              {{ d.id_comanda ? `Venda #${d.id_comanda}` : 'Débito Manual' }} - {{d.data_debito}}
                            </span>
                            <span class="d-block small text-nowrap">Vencimento: {{d.vencimento}}</span>
                            <span class="d-block small text-nowrap">
                              <span v-if="d.status === '2'">{{(d.valor_recebido) | valor }} - {{ d.nome_pagamento }}</span>
                              <span v-else>Valor: {{(d.valor) | valor }}</span>
                            </span>
                          </label>
                        </td>
                        <td class="text-right text-nowrap">
                          <button class="btn btn-sm text-secondary" @click="comprovanteDebito(d.id_debito)" title="Imprimir">
                            <i class="fa fa-print"></i>
                          </button>
                          <button class="btn btn-sm text-third" @click="editarDebito(d)" title="Visualizar">
                            <i class="fa fa-chevron-right"></i>
                          </button>
                        </td>
                      </tr>
                    </table>
                    <div class="d-flex justify-content-center align-items-center" style="min-height: 150px" v-if="!debitos.length">
                      <loading v-if="load"/>
                      <small v-else>Nenhum débito encontrado</small>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-4 mb-2">
                <div class="border rounded p-2">
                  <div class="mb-1">
                    {{total_aberto | valor}}
                    <div class="small font-weight-bold">Total em aberto</div>
                  </div>
                  {{total_vencido | valor}}
                  <div class="small font-weight-bold">Total vencido</div>
                </div>
                <div v-show="selecionados.length && pesquisa.status === '1'" class="border-top pt-2 mt-2">
                  <div class="mb-2">
                    <select title="Forma de Pagamento" class="form-control" id="debtForm" v-model="dados.id_pagamento" required>
                      <option value="" class="small" disabled>Forma de pagamento</option>
                      <option :value="f.id_pagamento" v-for="f in formas_pagamento">{{f.nome_pagamento}}</option>
                    </select>
                  </div>
                  <div>
                    <money class="form-control" v-model="dados.valor_pagamento"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-show="menu === 2">
            <div class="card p-2" v-if="dadosDebito.id_debito">
              <div>
                {{dadosDebito.data_debito}} - {{ dadosDebito.id_comanda ? ('Venda: ' + dadosDebito.id_comanda) : 'Débito Manual' }}
                <span class="badge badge-dark ml-1" v-if="dadosDebito.status === '2'">Pago</span>
                <span class="badge badge-success ml-1" v-else>Aberto</span>
              </div>
              <div v-if="dadosDebito.valor_recebido > 0">
                <b>Recebido:</b> {{dadosDebito.valor_recebido | valor}}
              </div>
              <div v-if="dadosDebito.id_caixa">
                <b>Caixa:</b> {{dadosDebito.id_caixa}}
              </div>
            </div>
            <div class="row no-gutters">
              <div class="col-md-6 pr-md-2 mb-1">
                <label class="mb-0 small">Valor</label>
                <money v-model="dadosDebito.valor" id="valorDebito" class="form-control" :disabled="dadosDebito.status === '2'"/>
              </div>
              <div class="col-md-6 mb-1">
                <label class="mb-0 small">Data Vencimento</label>
                <input type="date" class="form-control" id="dataVencimento" v-model="dadosDebito.data_vencimento" required :disabled="dadosDebito.status === '2'">
              </div>
              <div class="col-md-12 mb-3">
                <label class="mb-0 small">Observações</label>
                <textarea class="form-control" placeholder="Ex: Pego pelo André" rows="2" v-model="dadosDebito.obs_debito" :disabled="dadosDebito.status === '2'"></textarea>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-content-footer bg-light p-2 mt-2 border-top d-flex justify-content-between">
          <button class="btn btn-dark p-3" @click="menu === 1 ? modal = false : menu = 1">
            <i class="fa fa-chevron-left mr-2"></i>
            <span>Voltar</span>
          </button>
          <button class="btn btn-success" v-show="menu === 1 && selecionados.length" @click="finalizarDebito">
            <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-credit-card" width="20" height="20" viewBox="0 0 24 24" stroke-width="2" stroke="#fff" fill="none" stroke-linecap="round" stroke-linejoin="round">
              <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
              <rect x="3" y="5" width="18" height="14" rx="3" />
              <line x1="3" y1="10" x2="21" y2="10" />
              <line x1="7" y1="15" x2="7.01" y2="15" />
              <line x1="11" y1="15" x2="13" y2="15" />
            </svg>
            <span class="ml-2">Realizar Baixa</span>
          </button>
          <button class="btn btn-secondary" v-show="menu === 2 && dadosDebito.status === '1'" @click="editarIncluirDebito()">
            <i class="fa fa-check mr-2"></i>
            {{dadosDebito.id_debito ? 'Editar' : 'Adicionar'}} Débito
          </button>
        </div>
      </div>
    </div>

    <caixa ref="debCaixa" @finalizarVenda="finalizarDebito"/>
  </div>
</template>

<script>
  import Tooltip from "@/components/commons/Tooltip";
  import Caixa from "@/views/comanda/pdv/Caixa";
  import Loading from "@/components/commons/Loading";

  export default {
    name: "ClienteDebito",
    components: {Loading, Caixa, Tooltip},
    props: ['admin'],

    data() {
      return {
        token: localStorage.getItem('key'),
        formas_pagamento: [],
        selecionados: [],
        modal: false,
        menu: 1,
        load: false,
        dados: {
          id_pagamento: '',
          valor_pagamento: '',
          valor_debitos: '',
        },
        dadosDebito: {
          valor: 0,
          data_vencimento: '',
          obs_debito: ''
        },
        pesquisa: { status: '1' },
        cliente: {},
        debitos: [],

        total_vencido: 0,
        total_aberto: 0
      }
    },

    methods: {
      buscarFormasPagamento() {
        this.formas_pagamento = this.$store.state.pagamentos_empresa.filter(f => f.id_pagamento !== '2');
      },

      buscarDebitos() {
        this.debitos = [];
        this.selecionados = [];
        this.load = true;
        this.$http.get('pdv/clientes/debitos/' + this.token + '/' + this.cliente.id_cliente, {params: this.pesquisa})
          .then(response => {
            this.$store.state.load = false;
            this.load = false;

            if (!response.data) {
              return;
            }

            this.debitos = response.data.debitos || [];
            this.total_aberto = response.data.total_aberto || 0;
            this.total_vencido = response.data.total_vencido || 0;

          }, res => {
            this.$store.state.load = false;
            this.load = false;
            this.$swal(res.data.msg || 'Erro temporário');
          });
      },

      editarIncluirDebito() {
        if (this.dadosDebito.valor <= 0) {
          this.$swal('Por favor, informe o valor deste débito').then(() => {
            document.getElementById('valorDebito').focus();
          });
          return;
        }

        if (!this.dadosDebito.data_vencimento) {
          this.$swal('Por favor, selecione uma data de vencimento').then(() => {
            document.getElementById('dataVencimento').focus();
          });
          return;
        }

        this.$store.state.load = true;
        this.dadosDebito.id_cliente = this.cliente.id_cliente;

        this.$http.post('pdv/clientes/debitos/' + this.token, this.dadosDebito)
          .then(response => {
            this.pesquisa.status = '1';
            this.clear();

          }, res => {
            this.$store.state.load = false;
            this.$swal(res.data && res.data.msg ? res.data.msg : "Erro Temporário");
          });
      },

      incluirDebito() {
        this.dadosDebito = {
          valor: 0,
          data_vencimento: '',
          obs_debito: '',
          status: '1'
        }
        this.menu = 2;
        this.$helpers.focusElement('valorDebito')
      },

      editarDebito(d) {
        this.dadosDebito = {
          id_debito: d.id_debito,
          valor: d.valor,
          data_vencimento: d.data_vencimento,
          obs_debito: d.obs_debito,
          id_cliente: d.id_cliente,
          data_debito: d.data_debito,
          valor_recebido: d.valor_recebido,
          id_comanda: d.id_comanda,
          status: d.status,
          id_caixa: d.id_caixa
        }
        this.menu = 2;
      },

      removerDebito() {
        this.$swal({
          text: 'Deseja realmente remover este débito?',
          buttons: ['Não', 'Sim']
        }).then((res) => {
          if (res) {
            this.dadosDebito.remover = '1';
            this.editarIncluirDebito();
          }
        })
      },

      reabrirDebito() {
        this.$swal({
          text: 'Deseja realmente reabrir este débito?',
          buttons: ['Não', 'Sim']
        }).then((res) => {
          if (res) {
            this.dadosDebito.reabrir = '1';
            this.editarIncluirDebito();
          }
        })
      },

      comprovanteDebito(id_debito) {
        let debitos = [id_debito];

        if (!id_debito) {
          debitos = this.selecionados.map(s => s.id_debito)
        }

        let parDebitos = '?';

        debitos.forEach(d => {
          parDebitos += `debitos[]=${d}&`
        });

        const url = `${this.base_server}api/comprovante/debito/${this.token}${parDebitos}`;
        const empresa = localStorage.getItem('token');
        const titulo = 'Comprovante de ' + (id_debito ? 'Débito: ' + id_debito : 'Débitos')
        this.$helpers.imprimirUrl(this, url, empresa, titulo);
      },

      clear() {
        this.menu = 1;
        this.pesquisa.status = '1';
        this.dados.valor_debitos = 0;
        this.dados.valor_pagamento = 0;
        this.dadosDebito = {
          valor: 0,
          data_vencimento: '',
          obs_debito: ''
        }

        this.buscarDebitos();
      },

      selecionarCliente(dados) {
        if (!dados) {
          this.modal = false;
          return;
        }

        this.cliente = dados;
        this.clear();
      },

      finalizarDebito() {
        if (this.selecionados.find(s => s.status === '2')) {
          this.$swal('Não é possível dar baixa em débitos já pagos!');
          return;
        }

        if (!this.dados.id_pagamento) {
          this.$swal('Por favor, selecione uma forma de pagamento').then(() => {
            this.$helpers.focusElement('debtForm')
          });
          return;
        }

        this.dados.valor_pagamento = parseFloat(this.dados.valor_pagamento).toFixed(2);
        this.dados.valor_debitos = parseFloat(this.dados.valor_debitos).toFixed(2);

        if (parseFloat(this.dados.valor_pagamento) > parseFloat(this.dados.valor_debitos)) {
          this.$swal('O valor do pagamento é maior que os débitos. Por favor informe um valor válido.');
          return;
        }

        const diff = this.dados.valor_debitos - this.dados.valor_pagamento;
        const text = (diff > 0)
            ? `O valor do pagamento é menor que o valor dos débitos, será incluído um débito com o valor da diferença R$ ${diff.toFixed(2)}, ok?`
            :`Deseja dar baixa nestes débitos no valor de R$ ${this.dados.valor_pagamento}?`;

        this.$swal({ text, buttons: ['Cancelar', 'Sim']}).then((res) => {
          if (res) {
            this.baixarPagamentos();
          }
        });
      },

      baixarPagamentos() {
        this.$store.state.load = true;
        const dados = {
          debitos: this.selecionados.map(d => d.id_debito),
          ...this.dados
        }

        this.$http.post('pdv/clientes/debitos-pagamentos/' + this.token, dados)
          .then(response => {
            this.$store.state.load = false;

            if (response.data.result) {
              switch (response.data.result) {
                case 'success':
                  this.$swal({
                    text: "Débitos finalizadas com sucesso! Deseja imprimir o comprovante?",
                    buttons: ['Não', 'Sim']
                  }).then((res) => {
                    if (res) {
                      this.comprovanteDebito();
                    }

                    this.buscarDebitos();
                  });

                  break;

                case 'caixa':
                  this.$refs.debCaixa.abrirCaixa();
                  break;

                default:
                  this.$swal("Atenção!", response.data.message);
                  break;
              }
            }

          }, res => {
            this.$store.state.load = false;
            this.$swal(res.data.msg);
          });
      },

      selTodos() {
        if (this.debitos.length) {
          this.selecionados = (this.selecionados.length < this.debitos.length) ? this.debitos : [];
        }
      }
    },

    created() {
      this.$parent.$on('openDebitos', (dados) => {
        this.modal = true;
        this.buscarFormasPagamento();
        this.selecionarCliente(dados);
      });
    },

    watch: {
      selecionados() {
        let total = 0;

        this.selecionados.forEach((obj) => {
          total += parseFloat(obj.valor);
        });

        this.dados.valor_debitos = total;
        this.dados.valor_pagamento = total;
      }
    }
  }
</script>

<style scoped>
  .height-75 {
    height: calc(100vh - 282px);
  }

  .modal-pdv .modal-admin {
    margin-top: 74px;
  }
</style>
